import {Component, Input} from '@angular/core';
import {DocumentInfoUtilModel} from './model/document-info-util.model';
import {DatePipe} from '@angular/common';
import {DomSanitizer} from '@angular/platform-browser';

@Component({
  selector: 'ngx-document-info-util',
  templateUrl: './document-info-util.component.html',
  styleUrls: ['./document-info-util.component.scss'],
})
export class DocumentInfoUtilComponent {
  @Input() data?: any;

  constructor(public datepipe: DatePipe) {}

  capitalize(s) {
    return s[0].toUpperCase() + s.slice(1);
  }

  getData(name, time) {
    if (name) {
      return `<span class="small">${this.capitalize(name)}</span> <br>
            <span class="text-muted small">${this.datepipe.transform(time, 'MMM d, y')}</span>`;
    }

    return '-';
  }
}
